import React, { useState, useEffect } from "react";
import clsx from "clsx";
import { useFormChangeHandler } from "hooks/useFormChangeHandler";
import { useSubmitHandler } from "hooks/useSubmitHandler";
import { useCreateData, useUpdateData } from "hooks/useApiHooks";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import {
  IconCash,
  IconClockEdit,
  IconCloudDownload,
  IconListNumbers,
  IconPencil,
  IconPrinter,
  IconTable,
  IconTag,
  IconTrash,
} from "@tabler/icons-react";
import { useCanvasHandler } from "hooks/useCanvasHandler";
import CreatePage from "./create-page";
import ChangeOrderDate from "./canvas-order/change-order-date";
import PembayaranOrder from "./canvas-order/pembayaran-order";
import ChangeOrderStatus from "./canvas-order/change-order-status";
import ChangeSession from "./canvas-order/change-session";

const animatedComponents = makeAnimated();

const CardClickPage = ({ initialData, onSuccess, onError }) => {
  const API_URL = "/booking"; // API URL sesuai dengan endpoint booking Anda
  const [formData, setFormData] = useState({
    // productSelect: "",
    selectedProducts: [],
    price: "",
    quantity: 1,
  });

  const isUpdateMode = !!initialData;
  const { handleSuccess, handleError, showCanvasHandler } = useCanvasHandler();

  const { createData: createBooking, loading: creatingBooking } = useCreateData(
    API_URL,
    "bookings"
  );
  const { updateData: updateBooking, loading: updatingBooking } = useUpdateData(
    `${API_URL}/${initialData?.id}`,
    "bookings"
  );

  const { handleSubmit, isSubmitting, formError } = useSubmitHandler(
    isUpdateMode ? updateBooking : createBooking,
    onSuccess,
    onError
  );

  const handleBeforeSubmit = (e) => {
    e.preventDefault();
    const payload = {
      ...formData,
    };

    handleSubmit(payload, e);
  };

  useEffect(() => {
    if (initialData) {
      setFormData({
        ...initialData,
      });
    }
  }, [initialData]);

  const actions = [
    { icon: <IconTable size={24} />, label: "Detail Booking" },
    { icon: <IconClockEdit size={24} />, label: "Ganti Tanggal" },
    { icon: <IconPencil size={24} />, label: "Ubah Booking" },
    { icon: <IconListNumbers size={24} />, label: "Ganti Sesi" },
    { icon: <IconCash size={24} />, label: "Pembayaran Booking" },
    { icon: <IconTag size={24} />, label: "Ubah Status Booking" },
    {
      icon: <IconPrinter size={24} />,
      label: "Cetak Invoice Pelanggan",
      type: "customer",
    },
    {
      icon: <IconPrinter size={24} />,
      label: "Cetak Invoice Agen",
      type: "agent",
    },
    // { icon: <IconCloudDownload size={24} />, label: "Unduh Invoice Pelanggan" },
    // { icon: <IconCloudDownload size={24} />, label: "Unduh Invoice Agen" },
    {
      icon: <IconTrash size={24} color="red" />,
      label: "Hapus Booking",
      isDanger: true,
    },
  ];

  const handleAction = (e, action) => {
    e.preventDefault();
    // hideCanvas();

    if (action.label === "Detail Booking") {
      showCanvasHandler(
        "Detail Booking",
        // <DetailBooking order={order} />
        <CreatePage onSuccess={handleSuccess} onError={handleError} />
      );
    } else if (action.label === "Ganti Tanggal") {
      showCanvasHandler(
        "Ganti Tanggal",
        <ChangeOrderDate />
        // <ChangeOrderDate
        //   initialData={order}
        //   onSuccess={handleSuccess}
        //   onError={handleError}
        // />
      );
    } else if (action.label === "Ubah Booking") {
      showCanvasHandler(
        "Ubah Booking",
        <CreatePage
          initialData={initialData}
          onSuccess={handleSuccess}
          onError={handleError}
        />
        // <CreateBooking
        //   initialData={order}
        //   onSuccess={handleSuccess}
        //   onError={handleError}
        // />
      );
    } else if (action.label === "Pembayaran Booking") {
      showCanvasHandler(
        "Pembayaran Booking",
        <PembayaranOrder />
        // <PembayaranOrderList order={order} />
      );
    } else if (action.label === "Ubah Status Booking") {
      showCanvasHandler(
        "Ubah Status Booking",
        <ChangeOrderStatus />
        // <ChangeOrderStatus
        //   initialData={order}
        //   onSuccess={handleSuccess}
        //   onError={handleError}
        // />
      );
    } else if (action.label === "Hapus Booking") {
      e.stopPropagation();
      // handleDelete(order.id)
    } else if (action.label === "Cetak Invoice Pelanggan") {
      // printInvoicePelanggan()
    } else if (action.label === "Cetak Invoice Agen") {
      // printInvoiceAgent()
      // } else if (action.label === "Unduh Invoice Pelanggan") {
      // downloadInvoice({ invoice_to: "customer" })
      // } else if (action.label === "Unduh Invoice Agen") {
      // downloadInvoice({ invoice_to: "agent" })
    } else if (action.label === "Revision Order") {
      showCanvasHandler(
        "Revision Order"
        // <CreateBooking
        //   initialData={order}
        //   onSuccess={handleSuccess}
        //   onError={handleError}
        //   isRevision={true}
        // />
      );
    } else if (action.label === "Ganti Sesi") {
      showCanvasHandler(
        "Ganti Sesi",
        <ChangeSession />
        // <ChangeSession
        //   initialData={order}
        //   onSuccess={handleSuccess}
        //   onError={handleError}
        // />
      );
    } else {
      return null;
    }
  };

  return (
    <>
      {/* card untuk menampilkan sedikit detail dari booking, seperti
      produk/akitfitas yang dipilih, jumlah tamu  */}
      <div className="card card-md mb-3">
        <div className="card-body">
          <h4 className="card-title">Booking #123456</h4>
          <div className="d-flex justify-content-between">
            <div>
              <p className="text-muted">Tanggal: 12 Januari 2022</p>
              <p className="text-muted">Sesi: 09.00 - 11.00</p>
              <p className="text-muted">
                Produk/Aktivitas: Single (1) & Tandem (1)
              </p>
              <p className="text-muted">Jumlah Tamu: 2</p>
            </div>
            <div>
              <p className="text-muted">
                Status: <span className="text-success">Active</span>
              </p>
              <p className="text-muted">Total: Rp. 100.000</p>
            </div>
          </div>
        </div>
      </div>
      <form
        onSubmit={handleBeforeSubmit}
        className="d-flex flex-column"
        style={{ height: "100%" }}
      >
        <ul>
          {actions.map((action, index) => (
            <li
              key={index}
              className={`mb-5 d-flex align-items-center cursor-pointer ${
                action.isDanger ? "text-danger" : ""
              }`}
              onClick={(e) => handleAction(e, action)}
            >
              {action.icon}
              <span className="ms-2">{action.label}</span>
            </li>
          ))}
        </ul>
        {/* Submit Button */}
        {/* <div className="form-group mt-auto d-grid">
        <button
          type="submit"
          className="btn btn-primary btn-block"
          disabled={isSubmitting}
        >
          {isUpdateMode ? "Update Booking" : "Create Booking"}
        </button>
      </div> */}
      </form>
    </>
  );
};

export default CardClickPage;
